<div class="content-body">
  <form [formGroup]="subscriptionForm">
    <div class="d-flex gap-30">
      <div class="form-field">
        <mat-radio-group
          aria-label="Select an option"
          formControlName="isActive"
        >
          <mat-radio-button value="1" class="mr-1">Active</mat-radio-button>
          <mat-radio-button value="0">Inactive</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="d-flex gap-30">
      <div class="form-field datepicker">
        <p>Start Date</p>
        <mat-form-field appearance="fill">
          <input
            matInput
            formControlName="startDate"
            [matDatepicker]="startDatePicker"
            autocomplete="off"
            (change)="commonService.validateDate($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-field datepicker">
        <p>End Date</p>
        <mat-form-field appearance="fill">
          <input
            matInput
            formControlName="endDate"
            [matDatepicker]="endDatePicker"
            autocomplete="off"
            (change)="commonService.validateDate($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="form-field wp-100 textarea">
      <p>Notes</p>
      <mat-form-field>
        <textarea
          maxlength="{{ maxLength.maxLength2000 }}"
          matInput
          formControlName="note"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</div>
